import React from 'react'
import { FormValueObject } from '#src/components/Path/Form'
import { IdPathFlowQuestionDefinition } from '#src/components/Path/Question'
import { IdPathFlowQuestionType } from '#src/generated/graphql'
import { FormContextConsumer, FormContextType } from '#src/components/Path/FormContext'
import MediaUploadQuestion from './MediaUploadQuestion'
import ExpertSelectionQuestion from './ExpertSelectionQuestion'
import FlightPlanQuestion from './FlightPlanQuestion'

export interface IdQuestionProps extends IdPathFlowQuestionDefinition<{}> {}

class IdPathFlowQuestion extends React.PureComponent<
  IdPathFlowQuestionDefinition<{}> & { context: FormContextType }
> {
  constructor(props: IdPathFlowQuestionDefinition<{}> & { context: FormContextType }) {
    super(props)

    this.state = {}

    this.handleFieldValueChanged = this.handleFieldValueChanged.bind(this)
  }

  public componentDidMount() {
    const { question } = this.props

    if (question.idUserInput.value) {
      this.props.onFieldValidityChanged(true)
      this.props.onFieldValueChanged({
        value: question.idUserInput.value
      })
    }

    if (!question.required) {
      this.props.onFieldValidityChanged(true)
    }
  }

  public handleSetFieldInvalid(errorMessage?: string) {
    this.props.onFieldValidityChanged(false)

    this.setState({
      isValid: false,
      errorText: errorMessage || 'Please enter a valid value'
    })
  }

  public handleSetFieldValid() {
    this.props.onFieldValidityChanged(true)

    this.setState({
      isValid: true,
      errorText: undefined
    })
  }

  public handleFieldValueChanged(value: FormValueObject) {
    if (value === undefined && this.props.question.required) {
      this.handleSetFieldInvalid()
    } else {
      this.handleSetFieldValid()
    }

    this.props.onFieldValueChanged(value)
  }

  public render() {
    const { question } = this.props

    switch (question.idType) {
      case IdPathFlowQuestionType.MEDIA_ID_IMAGE_UPLOAD:
        return <MediaUploadQuestion {...this.props} />

      case IdPathFlowQuestionType.EXPERT_ID_SELECTION:
        return <ExpertSelectionQuestion {...this.props} />

      case IdPathFlowQuestionType.FLIGHT_PLAN:
        return <FlightPlanQuestion {...this.props} />

      default:
        throw new Error(`Unrecognized id type question initialized, [${IdPathFlowQuestionType}]`)
    }
  }
}

const IdPathFlowQuestionWithContext: React.SFC<IdPathFlowQuestionDefinition<{}>> = ({
  ...rest
}) => (
  <FormContextConsumer>
    {formData => (formData ? <IdPathFlowQuestion context={formData} {...rest} /> : null)}
  </FormContextConsumer>
)

export default IdPathFlowQuestionWithContext
